import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Typography } from "@material-ui/core"
import { formatNumber } from "accounting"
import { subscribe, unsubscribe } from "pubsub-js"
import { ADMIN_EVENT } from "types/pubsub"
import classnames from "classnames"
import update from "immutability-helper"

let highBidSub
let removeBidSub
let addDonationSub
let handRemoveSub
let drawRaffleSub
let fixedPurchaseSub
let rafflePurchaseSub
let displayTimeout
let displayingShoutout = false

class Shoutout extends Component {
  componentDidMount() {
    this.props.data.settings.events.forEach(event => {
      if (event === "bid_earnings") {
        // prevent double subscribing
        if (
          !this.state.subscriptions.highBid &&
          !this.state.subscriptions.removeBid
        ) {
          highBidSub = subscribe(`${ADMIN_EVENT}::highBid`, this.handleHighBid)
          removeBidSub = subscribe(
            `${ADMIN_EVENT}::removeBid`,
            this.handleHighBid
          )
          this.setState(
            update(this.state, {
              subscriptions: {
                highBid: {
                  $set: true
                },
                removeBid: {
                  $set: true
                }
              }
            })
          )
        }
      }

      if (event === "donation_earnings" || event === "donation_pledges") {
        // prevent double subscribing
        if (
          !this.state.subscriptions.addDonation &&
          !this.state.subscriptions.removePledge
        ) {
          addDonationSub = subscribe(
            `${ADMIN_EVENT}::addDonation`,
            this.handleAddDonation
          )
          handRemoveSub = subscribe(
            `${ADMIN_EVENT}::removePledge`,
            this.handleRemovePledge
          )
          this.setState(
            update(this.state, {
              subscriptions: {
                addDonation: {
                  $set: true
                },
                removePledge: {
                  $set: true
                }
              }
            })
          )
        }
      }

      if (event === "raffle_winners") {
        // prevent double subscribing
        if (!this.state.subscriptions.drawRaffle) {
          drawRaffleSub = subscribe(
            `${ADMIN_EVENT}::drawRaffle`,
            this.handleRaffleWinner
          )
          this.setState(
            update(this.state, {
              subscriptions: {
                drawRaffle: {
                  $set: true
                }
              }
            })
          )
        }
      }

      if (event === "fixed_purchase_earnings") {
        // prevent double subscribing
        if (!this.state.subscriptions.fixedPurchase) {
          fixedPurchaseSub = subscribe(
            `${ADMIN_EVENT}::fixedPurchase`,
            this.handleFixedPurchase
          )
          this.setState(
            update(this.state, {
              subscriptions: {
                fixedPurchase: {
                  $set: true
                }
              }
            })
          )
        }
      }

      if (event === "raffle_purchase_earnings") {
        // prevent double subscribing
        if (!this.state.subscriptions.rafflePurchase) {
          rafflePurchaseSub = subscribe(
            `${ADMIN_EVENT}::rafflePurchase`,
            this.handleRafflePurchase
          )
          this.setState(
            update(this.state, {
              subscriptions: {
                rafflePurchase: {
                  $set: true
                }
              }
            })
          )
        }
      }
    })
  }
  componentWillUnmount() {
    unsubscribe(highBidSub)
    unsubscribe(removeBidSub)
    unsubscribe(addDonationSub)
    unsubscribe(handRemoveSub)
    unsubscribe(fixedPurchaseSub)
    unsubscribe(rafflePurchaseSub)
    unsubscribe(drawRaffleSub)
  }
  state = {
    pastShoutouts: [],
    currentData: {
      number: 250,
      user: {
        first_name: "Jordan",
        last_name: "Riser",
        full_name: "Jordan Riser",
        paddle_number: 123
      },
      type: "donation"
    },
    subscriptions: {}
  }
  handleAddDonation = (msg, data) => {
    let shouldHandleDonation = false
    if (this.state.pastShoutouts.length === 0) {
      shouldHandleDonation = true
    } else {
      if (
        !this.state.pastShoutouts
          .filter(shoutout => shoutout.type === "donation")
          .find(donation => donation.id === data.donation_id)
      ) {
        shouldHandleDonation = true
      }
    }
    if (shouldHandleDonation) {
      //SHOW CONFETTI
      // console.log(data)
      this.showNewShoutout({
        number: parseInt(data.donation_amt, 10),
        user: {
          full_name: data.user_name,
          first_name: data.first_name,
          last_name: data.last_name,
          paddle_number: data.paddle_number
        },
        id: data.donation_id,
        type: "donation"
      })
    }
  }


  handleFixedPurchase = (msg, data) => {
    let shouldhandleFixedPurchase = false
    if (this.state.pastShoutouts.length === 0) {
      shouldhandleFixedPurchase = true
    } else {
      if (
        !this.state.pastShoutouts
          .filter(shoutout => shoutout.type === "fixed")
          .find(fixed => fixed.id === data.purchase_id)
      ) {
        shouldhandleFixedPurchase = true
      }
    }
    if (shouldhandleFixedPurchase) {
      //SHOW CONFETTI
      // console.log(data)
      this.showNewShoutout({
        number: parseInt(data.purchase_amount, 10),
        user: {
          full_name: data.user_name,
          first_name: data.first_name,
          last_name: data.last_name,
          paddle_number: data.paddle_number
        },
        id: data.purchase_id,
        type: "fixed"
      })
    }
  }


  handleHighBid = (msg, data) => {
    this.showNewShoutout({
      number: data.current_high_bid,
      user: {
        full_name: data.full_name,
        first_name: data.first_name,
        last_name: data.last_name,
        paddle_number: data.paddle_number
      },
      type: "bid"
    })
  }
  handleRaffleWinner = (msg, data) => {
    this.showNewShoutout({
      number: 0,
      user: {
        full_name: data.full_name,
        first_name: data.first_name,
        last_name: data.last_name,
        paddle_number: data.paddle_number
      },
      type: "raffle"
    })
  }
  showNewShoutout = data => {
    if (displayingShoutout === false) {
      displayingShoutout = true

      this.setState({
      //showContent: false
      })
      setTimeout(() => {
        // console.log("timeout 300")
        this.setState(
          update(this.state, {
            currentData: {
              $set: data
            },
            pastShoutouts: {
              $push: [data]
            }
          })
        )
        setTimeout(() => {
          // console.log("timeout 50")
          this.setState({
            showContent: true
          })
        }, 50)

        // 8 second timeout and clear shoutout
        // if( typeof displayTimeout !== "undefined"){
        //   clearTimeout(displayTimeout)
        // }
        displayTimeout = setTimeout(() => {
          // console.log("timeout 8000")
          displayingShoutout = false
          this.setState({
            showContent: false
          })
        }, 8000)

      }, 300)
    }
  }
  render() {
    const { classes } = this.props
    return (
      <div className={classes.container}>
        <div
          className={classnames(classes.left, {
            [classes.leftIn]: this.state.showContent
          })}
        >
          <Typography className={classes.number}>
            {this.state.currentData.type === "raffle" && "Winner!"}
            {this.state.currentData.type !== "raffle" &&
              `$${formatNumber(this.state.currentData.number)}`}
          </Typography>
        </div>
        <div
          className={classnames(classes.right, {
            [classes.rightIn]: this.state.showContent
          })}
        >
          <Typography className={classes.name} style={{
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "inline-block", 
          }} >
            {this.state.currentData.user[this.props.data.settings.name_style]}
          </Typography>
          {this.state.currentData.type === "donation" && (
            <Typography className={classes.thankYou}>
              Thank you for your donation!
            </Typography>
          )}
          {this.state.currentData.type === "bid" && (
            <Typography className={classes.thankYou}>
              Thank you for your bid!
            </Typography>
          )}
          {this.state.currentData.type === "raffle" && (
            <Typography className={classes.thankYou}>
              Congratulations!
            </Typography>
          )}
          {this.state.currentData.type === "fixed" && (
            <Typography className={classes.thankYou}>
              Thank you!
            </Typography>
          )}

          
        </div>
        {!this.state.showContent && (
          <Typography className={classes.placeDonationText}>
            Place a donation or a bid now!
          </Typography>
        )}
      </div>
    )
  }
}

export default compose(
  connect(),
  withStyles(styles, { withTheme: true })
)(Shoutout)



// WEBPACK FOOTER //
// ./src/components/Template/Blocks/Shoutouts/index.jsx